import React from 'react'
import PropTypes from 'prop-types'

export const LogoAlt = ({ fillcolor, className }) => (
  <svg width="300" height="29" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M39.1 19l-3.4-6-3.4 6h6.8zm-4.4-8h2.1l7.6 12.8h-2.6l-1.7-3h-8.8l-1.6 3h-2.4l7.4-12.7z" fill={fillcolor} />
    <path d="M50.4 16v7.8h-2.2V11.1H50l9.4 8.3c.6.5 1 1 1.5 1.7-.2-.8-.2-1.6-.2-2.3V11h2.2v12.7h-1.7l-9.5-8.4c-.5-.5-1-1-1.5-1.8l.2 2.3z" fill={fillcolor}/>
    <path d="M72.2 13v8.9h4.6c3.9 0 5.8-1 5.8-4.5 0-3.3-2-4.4-5.8-4.4h-4.6zm10-1c1.7 1.1 2.8 3.1 2.8 5.4 0 4.3-2.6 6.4-7.9 6.4h-7.3V11.1H77c2.2 0 4 .2 5.1 1z" fill={fillcolor} />
    <path d="M93 11.1h-2.4v12.7H93V11.1z" fill={fillcolor} />
    <path d="M108.6 19l-3.4-6-3.4 6h6.8zm-4.5-8h2.2l7.5 12.8h-2.6l-1.6-3h-8.8l-1.6 3h-2.5l7.4-12.7z" fill={fillcolor} />
    <path d="M119.9 16v7.8h-2.2V11.1h1.8l9.3 8.3c.6.5 1 1 1.5 1.7l-.2-2.3V11h2.3v12.7h-1.7l-9.5-8.4c-.6-.5-1-1-1.5-1.8l.2 2.3z" fill={fillcolor} />
    <path d="M144.4 23.8H142V13h-6v-2h14.4v2h-6v10.8z" fill={fillcolor} />
    <path d="M14.5 22.9L10 17v6.8h10.3v-6.5L16 22.9h-1.6zM.1.4v23.4h6V10.3h3.4l5.9 7.6 5.3-7.6h2.8V.4H.1z" fill={fillcolor} />
    <path d="M152.7 9.2h-.4v.7h.9v-.4c0-.2-.1-.3-.5-.3zm0-.2c.6 0 1 .1 1 .5l-.2.4-.4.1.5 1h-.4l-.4-1h-.5v1h-.3V9h.8zm1.6 1c0-.4-.2-.8-.5-1.1-.3-.3-.6-.5-1-.5-.5 0-.9.2-1.2.5a1.5 1.5 0 000 2.2c.3.3.7.4 1.1.4.5 0 .8-.1 1.1-.4.3-.3.5-.7.5-1.1zm-1.6-1.7c.5 0 1 .1 1.3.5.3.3.5.7.5 1.2s-.2.9-.5 1.2c-.4.4-.8.5-1.3.5-.4 0-.9-.1-1.2-.5a1.7 1.7 0 010-2.5c.3-.3.7-.4 1.2-.4z" fill={fillcolor} />

    <path d="M180 11h5.2c4.4 0 7.4 2.8 7.4 6.4 0 3.6-3 6.4-7.4 6.4H180V11.1zm2.4 2.1v8.7h2.8c2.9 0 4.8-1.8 4.8-4.3 0-2.6-1.9-4.4-4.8-4.4h-2.8z" fill={fillcolor} />
    <path d="M223.3 11h2.2L233 20V11h2.4v12.7h-2l-7.7-9v9h-2.4V11.1z" fill={fillcolor} />
    <path d="M242.4 13.1H238v-2h11.2v2h-4.4v10.7h-2.4V13.1z" fill={fillcolor} />
    <path d="M280.5 11h10.3v2h-8v3.4h7v2h-7v3.4h8v2h-10.3V11.1z" fill={fillcolor} />
    <path d="M274.2 16.6v5.2h-2.8c-2.9 0-4.8-1.9-4.8-4.4 0-2.5 1.9-4.3 4.8-4.3h5.2v-2h-5.2c-4.3 0-7.4 2.8-7.4 6.3 0 3.7 3 6.4 7.4 6.4h5.2v-7.2h-2.4z" fill={fillcolor} />
    <path d="M170.3 11l-7.2 12.8h2.5l4.7-8.5 4.7 8.5h2.6l-7.3-12.7z" fill={fillcolor} />
    <path d="M200.6 23.8l7.2-12.7h-2.5l-4.7 8.5-4.7-8.5h-2.6l7.3 12.7z" fill={fillcolor} />
    <path d="M256 11l-7.2 12.8h2.6l4.7-8.5 4.7 8.5h2.6L256 11.1z" fill={fillcolor} />
    <path d="M214.1 7.9l-6.6 11.6h2.3l4.3-2.8 4.3 2.8h2.3l-6.6-11.6z" fill={fillcolor} />
  </svg>
)

LogoAlt.propTypes = {
  fillcolor: PropTypes.string,
  className: PropTypes.string
}

LogoAlt.defaultProps = {
  fillcolor: '#e8e8e8',
}

export default LogoAlt
